import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaCheckCircle, FaTimesCircle, FaCircle } from "react-icons/fa";
import toast from "react-hot-toast";
import { Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { updateStaffAttendanceStatus } from "../../../../../Store/Slices/Admin/staffAttendance/staffAttendance.slice";
import profileIcon from "../../../../../Assets/DashboardAssets/profileIcon.png";
const AttendanceTable = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("admClass");
  const { attendanceData, filters, loading } = useSelector(
    (state) => state.admin.staffAttendance
  );

  const handleAttendanceChange = (StaffId, status) => {
    dispatch(updateStaffAttendanceStatus({ StaffId, status }));
  };

  // Skeleton rows that match the table structure
  const skeletonRows = Array(10).fill(
    <tr className="text-center border-b h-12">
      <td className="py-2 border-gray-300">
        <Skeleton.Avatar active size="small" shape="square" />
      </td>
      <td className="py-2 border-gray-300">
        <Skeleton.Input active size="small" style={{ width: 60 }} />
      </td>
      <td className="py-2 border-gray-300 flex items-center justify-start ps-6">
        <Skeleton.Avatar active size="small" shape="circle" />
        <Skeleton.Input
          active
          size="small"
          style={{ width: 100, marginLeft: 8 }}
        />
      </td>
      <td className="py-2 border-gray-300">
        <Skeleton.Avatar active size="small" shape="circle" />
      </td>
      <td className="py-2 border-gray-300">
        <Skeleton.Avatar active size="small" shape="circle" />
      </td>
      <td className="py-2 border-gray-300">
        <Skeleton.Avatar active size="small" shape="circle" />
      </td>
    </tr>
  );

  return (
    <div className="w-full  overflow-x-hidden overflow-y-auto pb-10 h-full no-scrollbar max-h-[calc(100vh-64px)]">
      <div className="overflow-y-scroll h-128 no-scrollbar border">
        <table className="min-w-full bg-white rounded-lg">
          <thead className="sticky top-0 bg-white">
            <tr className="py-2 bg-gray-50">
              <th className="py-2 border-b border-gray-300">{t("SL")}</th>
              <th className="py-2 border-b border-gray-300">{t("Employee Id")}</th>
              <th className="py-2 ps-10 border-b border-gray-300 flex justify-start">
                {t("Name")}
              </th>
              <th className="py-2 border-b border-gray-300">{t("Present")}</th>
              <th className="py-2 border-b border-gray-300">{t("Absent")}</th>
              <th className="py-2 border-b border-gray-300">{t("Leave")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              skeletonRows
            ) : attendanceData?.length > 0 ? (
              attendanceData?.map((staff, index) => (
                <tr
                  key={staff.StaffId}
                  className="text-center border-b h-12"
                >
                  <td className="py-2 border-gray-300">{index + 1}</td>
                  <td className="py-2 border-gray-300">
                    {staff.employeeID}
                  </td>
                  <td className="py-2 border-gray-300 flex items-center justify-start ps-6">
                    <img
                      src={staff.profile || profileIcon}
                      alt="profile"
                      className="w-8 h-8 rounded-full me-2"
                    />
                    {staff.name}
                  </td>
                  <td className="py-2 border-gray-300">
                    <button
                      onClick={() =>
                        handleAttendanceChange(staff.StaffId, "present")
                      }
                      className="p-2 rounded"
                    >
                      <FaCheckCircle
                        className={`text-green-500 ${staff.attendanceStatus === "present"
                          ? "opacity-100"
                          : "opacity-30"
                          }`}
                        size={20}
                      />
                    </button>
                  </td>
                  <td className="py-2 border-gray-300">
                    <button
                      onClick={() =>
                        handleAttendanceChange(staff.StaffId, "absent")
                      }
                      className="p-2 rounded"
                    >
                      <FaTimesCircle
                        className={`text-red-500 ${staff.attendanceStatus === "absent"
                          ? "opacity-100"
                          : "opacity-30"
                          }`}
                        size={20}
                      />
                    </button>
                  </td>
                  <td className="py-2 border-gray-300">
                    <button
                      onClick={() =>
                        handleAttendanceChange(staff.StaffId, "leave")
                      }
                      className="p-2 rounded-full"
                    >
                      <FaCircle
                        className={`text-yellow-500 ${staff.attendanceStatus === "leave"
                          ? "opacity-100"
                          : "opacity-30"
                          }`}
                        size={20}
                      />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="text-center text-2xl py-10 text-gray-400"
                  colSpan={6}
                >
                  {t("No Staff Data Found")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceTable;
